import { render, staticRenderFns } from "./queryTool.vue?vue&type=template&id=2c507a6d&scoped=true&"
import script from "./queryTool.vue?vue&type=script&lang=ts&"
export * from "./queryTool.vue?vue&type=script&lang=ts&"
import style0 from "./queryTool.vue?vue&type=style&index=0&id=2c507a6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c507a6d",
  null
  
)

export default component.exports